import React from 'react';
import { Avatar, Typography, Box, SxProps, Theme } from '@mui/material';
import { ISound } from '../../types/global/helper';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { sound_icon } from '../../asset/images';
import { Image } from '@chakra-ui/react';

// Default sound thumbnail image (Replace with the actual path)

interface RoundImageWithTextProps {
    imageSize?: number;
    sound?: ISound;
    containerStyles?: SxProps<Theme>;
    onClick?: () => void;
}

const SoundAvatar: React.FC<RoundImageWithTextProps> = ({ imageSize = 50, containerStyles, sound, onClick }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box display="flex" alignItems="center" sx={containerStyles}>
            {sound?.thumbnail ? (
                <Avatar
                    src={sound?.thumbnail}
                    alt={sound?.title || 'Default Sound'}
                    onClick={onClick}
                    sx={{
                        width: imageSize,
                        height: imageSize,
                        marginRight: 1,
                        border: `0.2px solid ${theme[themeStyle].tag_white}`,
                    }}
                />
            ) : (
                <Image
                    onClick={onClick}
                    alt={sound?.title || 'Default Sound'}
                    src={sound_icon}
                    style={{
                        width: imageSize,
                        height: imageSize,
                        borderRadius: '50%',
                        marginRight: 8,
                        border: `0.2px solid ${theme[themeStyle].tag_white}`,
                    }}
                />
            )}
            <Typography
                style={{
                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                    color: theme[themeStyle].lightWhite,
                    fontSize: 12,
                    textTransform: 'capitalize',
                }}>
                {sound?.title || 'Unknown Sound'}
            </Typography>
        </Box>
    );
};

export { SoundAvatar };
